const Textarea = ({
  form,
  errors,
  rows,
  title,
  placeholder,
  id,
  style,
}: any) => {
  return (
    <div>
      <div className="label">
        <span className="label-text">{title}</span>
      </div>
      <label className="flex items-center">
        <textarea
          id={id}
          style={style}
          {...form.register(id)}
          placeholder={placeholder}
          rows={rows ? rows : 10}
          className={`textarea textarea-bordered w-full bg-white border-[1px] border-gray-300`}
        />
      </label>

      <div className="label">
        <span className="label-text-alt">
          {errors[id] && (
            <span style={{ color: "red" }}>{errors[id].message}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default Textarea;
